/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimulationDocumentDto } from './SimulationDocumentDto';
import {
    SimulationDocumentDtoFromJSON,
    SimulationDocumentDtoFromJSONTyped,
    SimulationDocumentDtoToJSON,
    SimulationDocumentDtoToJSONTyped,
} from './SimulationDocumentDto';

/**
 * 
 * @export
 * @interface GetSimulationDocumentsResponseDto
 */
export interface GetSimulationDocumentsResponseDto {
    /**
     * 
     * @type {Array<SimulationDocumentDto>}
     * @memberof GetSimulationDocumentsResponseDto
     */
    documents: Array<SimulationDocumentDto>;
}

/**
 * Check if a given object implements the GetSimulationDocumentsResponseDto interface.
 */
export function instanceOfGetSimulationDocumentsResponseDto(value: object): value is GetSimulationDocumentsResponseDto {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function GetSimulationDocumentsResponseDtoFromJSON(json: any): GetSimulationDocumentsResponseDto {
    return GetSimulationDocumentsResponseDtoFromJSONTyped(json, false);
}

export function GetSimulationDocumentsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSimulationDocumentsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(SimulationDocumentDtoFromJSON)),
    };
}

export function GetSimulationDocumentsResponseDtoToJSON(json: any): GetSimulationDocumentsResponseDto {
    return GetSimulationDocumentsResponseDtoToJSONTyped(json, false);
}

export function GetSimulationDocumentsResponseDtoToJSONTyped(value?: GetSimulationDocumentsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['documents'] as Array<any>).map(SimulationDocumentDtoToJSON)),
    };
}

